import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-database",
  "use": "icon-database-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-database\"><path d=\"M856.3 160H166.2c-4 0-7.3 3.3-7.3 7.3v690.1c0 4 3.2 7.3 7.3 7.3h690.1c4 0 7.3-3.3 7.3-7.3V167.3c0-4-3.3-7.3-7.3-7.3z m-56.7 64v149.6H222.9V224h576.7z m0 213.6v149.8H222.9V437.6h576.7zM222.9 800.7V651.4h576.6v149.3H222.9z\" /><path d=\"M475.7 264.9h70.4v64h-70.4zM601.5 264.9h157.1v64H601.5zM475.7 478.9h70.4v64h-70.4zM601.5 478.9h157.1v64H601.5zM475.7 692.8h70.4v64h-70.4zM601.5 692.8h157.1v64H601.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol